module.exports = __webpack_public_path__ + "static/logo-asdp-232bfda8af13d9a39d4371229e6adcad.png";